import { Component, OnInit } from '@angular/core';
import {PopinService} from '../services/popin.service';
import {Data} from '../providers/data.provider';
import {Product} from '../models/product.model';
import {PopinOneComponent} from '../popin-one/popin-one.component';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-popin-two',
  templateUrl: './popin-two.component.html',
  styleUrls: ['./popin-two.component.scss']
})
export class PopinTwoComponent implements OnInit {

  constructor(private popinService: PopinService,
              private data: Data) { }
  public static companyProducts: Product[];
  public adminManager: any;
  public visitRandomId: string;
  public uri: string;
  public customerName: string;
  public customerIdentifier: string;
  public customerCity: string;
  public customerActivity: string;
  public productList = {
    1: {
      id: '',
      name: '',
    },
    2: {
      id: '',
      name: '',
    },
    3: {
      id: '',
      name: '',
    },
  };

  ngOnInit(): void {
    this.visitRandomId = PopinOneComponent.visitRandomId;
    this.uri = encodeURIComponent(PopinOneComponent.uri);
    this.customerName = PopinOneComponent.customer.RaisonSociale;
    this.customerCity = PopinOneComponent.customer.Ville;
    this.customerActivity = PopinOneComponent.customer.LibelleNAF;
    this.customerIdentifier = PopinOneComponent.customer.SIREN;
    this.adminManager = this.data.storage.companyAccount.adminManager;

    this.popinService.getAccountProducts(this.data.storage.companyAccount._id)
      .then(products => {
        PopinTwoComponent.companyProducts = products as Product[];

        const productCustomer = [];
        for (const prd of PopinOneComponent.productCustomer) {
          productCustomer.push(prd._id);
        }

        let index = 0;
        for (const prd of products as Product[]) {
          if (index < 3 && productCustomer.includes(prd._id)) {
            index++;
            this.productList[index].id = prd._id;
            this.productList[index].name = prd.name;
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

}
